/* eslint-disable */

import clsx from 'clsx';
import { ReactNode } from 'react';
import { EpInfoCard } from '../../components';
import { accessCodeNormalize } from '../../components/HookFormComponents/Utils/accessCodeNormalize';
import {
  EpButton,
  EpStepContent,
} from '../../components/HookFormComponents/components';
import { useTranslation as t } from '../../hooks/useTranslation';
import styles from './EpConfirmationTemplate.module.scss';

export interface IAccessCodeStateProps {
  code: string | null;
  clinicalPharmacyId?: string | null;
  password?: string | null;
}

interface INotificationContent extends IAccessCodeStateProps {
  takeNotificationIdTextCopy: () => void;
  takeNotificationPrint: () => void;
  takeNotificationSendMail?: (arg?: string) => void;
  translations: unknown;
}

export const ContentId = ({
  children,
  label,
}: {
  children: ReactNode;
  label: string;
}) => (
  <div>
    <p className={styles['content__txt']}>{label}</p>
    <p
      className={clsx(
        styles['content__txt'],
        styles['content__txt--lg'],
        styles['content__txt--center'],
      )}
    >
      {children}
    </p>
  </div>
);

{
  /** Anônimo / Não anônimo */
}
export const NotificationSuccessSend = ({
  translations,
}: {
  translations: unknown;
}) => (
  <EpInfoCard
    customHeaderType={'success'}
    title={t(translations, 'Notification sent successfully!')}
    type={'filled'}
  >
    <p className={styles['content__txt']}>
      {t(
        translations,
        'The Quality Office and/or Patient Safety Center thanks you for your notification.',
      )}
    </p>
  </EpInfoCard>
);

{
  /** Farmácia clínica */
}
export const NotificationSuccessSendClinicalPharmacy = ({
  code,
  translations,
}: {
  code: string;
  translations: unknown;
}) => {
  return (
    <EpInfoCard
      customHeaderType={'success'}
      title={t(translations, 'Notification sent successfully!')}
      type={'filled'}
    >
      <p className={styles['content__txt']}>
        {t(
          translations,
          'Your clinical pharmacy notification number is {0}',
        ).replace('{0}', code)}
      </p>
      {/* <p className={styles['content__txt']}>
        {t(
          translations,
          'This notification will be forwarded to the Quality Office and/or Patient Safety Center, as it meets the incident notification criteria',
        )}
      </p> */}
    </EpInfoCard>
  );
};

{
  /** Anônimo / Não anônimo */
}
export const NotificationContent = ({
  code,
  password,
  takeNotificationIdTextCopy,
  takeNotificationPrint,
  translations,
}: INotificationContent) => (
  <div className={clsx(styles['content__mb'], styles['content__mt'])}>
    {code && (
      <EpStepContent.Card
        title={t(
          translations,
          'Write down the number and password of the notification to follow up in the future.',
        )}
      >
        <div className={styles['content__id']}>
          {code && (
            <ContentId label={t(translations, 'Your notification number is')}>
              {accessCodeNormalize(code as string)}
            </ContentId>
          )}
          {password && (
            <ContentId label={t(translations, 'Access password')}>
              {password}
            </ContentId>
          )}
        </div>

        <div className={clsx(styles['content__btn'], styles['not-printable'])}>
          <EpButton
            buttonSize="md"
            buttonText={t(translations, 'Copy')}
            buttonType="link-primary"
            buttonLeftIconName="SolidCopy"
            buttonOnClickFunc={() => takeNotificationIdTextCopy()}
          />
          <EpButton
            buttonSize="md"
            buttonText={t(translations, 'Print')}
            buttonType="link-primary"
            buttonLeftIconName="SolidPrint"
            buttonOnClickFunc={() => takeNotificationPrint()}
          />
          {password && (
            <EpButton
              buttonId="btn-share-email-modal"
              buttonSize="md"
              buttonType="link-primary"
              buttonDataBsTarget="#share-email-modal"
              buttonDataBsToggle="modal"
              buttonLeftIconName="SolidPaperPlane"
              buttonText={t(translations, 'Share data via email')}
            />
          )}
        </div>
      </EpStepContent.Card>
    )}
  </div>
);

{
  /** Farmácia clínica */
}
export const NotificationContentClinicalPharmacy = ({
  code,
  password,
  takeNotificationIdTextCopy,
  takeNotificationPrint,
  translations,
}: INotificationContent) => (
  <div className={clsx(styles['content__mt'])}>
    {code && (
      <EpStepContent.Card
        title={t(translations, 'Go to my notifications link to follow up.')}
      >
        <div className={styles['content__id']}>
          <ContentId label={t(translations, 'Your notification number is')}>
            {accessCodeNormalize(code as string)}
          </ContentId>
        </div>

        <div className={clsx(styles['content__btn'], styles['not-printable'])}>
          <EpButton
            buttonSize="md"
            buttonText={t(translations, 'Copy')}
            buttonType="link-primary"
            buttonLeftIconName="SolidCopy"
            buttonOnClickFunc={() => takeNotificationIdTextCopy()}
          />
          <EpButton
            buttonSize="md"
            buttonText={t(translations, 'Print')}
            buttonType="link-primary"
            buttonLeftIconName="SolidPrint"
            buttonOnClickFunc={() => takeNotificationPrint()}
          />
          {password && (
            <EpButton
              buttonId="btn-share-email-modal"
              buttonSize="md"
              buttonType="link-primary"
              buttonDataBsTarget="#share-email-modal"
              buttonDataBsToggle="modal"
              buttonLeftIconName="SolidPaperPlane"
              buttonText={t(translations, 'Share data via email')}
            />
          )}
        </div>
      </EpStepContent.Card>
    )}
  </div>
);
